<template>
  <div class="text-white w-100 px-md-5">
    <h1 class="mb-5">
      Reset Password
    </h1>

    <form action="resetPassword" class="d-flex flex-column">
      <input
        type="text"
        v-model="email"
        class="mb-4"
        placeholder="Email address"
        name="email"
      />
      <button
        type="submit"
        class="btn btn-light-blue mb-4"
        @click.prevent="resetPassword"
      >
        Reset Password
      </button>

      <div>
        Go back to
        <span @click="$router.push({ name: 'Login' })"
          ><u>Login <i class="fa fa-chevron-right"></i></u
        ></span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapActions({
      sendPasswordResetEmail: "sendPasswordResetEmail"
    }),
    async resetPassword() {
      try {
        await this.sendPasswordResetEmail(this.email);
        this.$toasted.show(
          "if the email exist, you will receive an email shortly",
          {
            theme: "bubble",
            position: "top-right",
            duration: 5000
          }
        );
      } catch (err) {
        this.$toasted.show("Sorry, something went wrong. Please try again", {
          theme: "bubble",
          position: "top-right",
          duration: 5000
        });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
